import React, { useMemo } from "react";
import GradeSimpleDetail from "./GradeSimpleDetail";
import { Ptag } from "components/core";
import { colors } from "theme";
import { formatToRs } from "utlis/utils";
import { maternityOrder } from "../schema";
import GradeTable from "./GradeTable";
import { Divider } from "@mui/material";
import { DividerHidden } from "pages/v1/PlanOverview/styles";

function RenderGradeSummarySwitch({ name, attributeData, grade, reusables, id }) {
  const childrenAgeLimitExist = useMemo(() => {
    return (
      grade?.dependents_covered?.children_age_limit?.min ||
      grade?.dependents_covered?.children_age_limit?.max
    );
  }, [grade]);

  const parentAgeLimitExist = useMemo(() => {
    return (
      grade?.dependents_covered?.parental_age_limit?.min ||
      grade?.dependents_covered?.parental_age_limit?.max
    );
  }, [grade]);

  const renderMaternity = () => {
    const attributes =
      attributeData?.attribute_additional_data &&
      Object.keys(attributeData?.attribute_additional_data);
    if (!attributes) return null;
    if (attributes.includes("metro")) {
      return (
        <GradeSimpleDetail title="Maternity Coverage">
          <section
            className="grade-summary-inner"
            style={{
              marginBottom: "30px",
            }}
          >
            {attributes.map((attr, attrIndex) => {
              const title =
                attr === "metro" ? "Metro Cities" : "Non-Metro Cities";

              const deliveryCoverage =
                attributeData?.attribute_additional_data[attr][
                "Delivery Coverage"
                ];
              const newBornCover =
                attributeData?.attribute_additional_data[attr][
                "New Born Cover"
                ];
              const prePostNatal =
                attributeData?.attribute_additional_data[attr][
                "Pre/Post Natal Cover"
                ];
              return (
                <>
                  {attrIndex !== 0 && (
                    <DividerHidden
                      style={{
                        margin: "36px 0px",
                      }}
                    />
                  )}
                  <section>
                    <Ptag fontSize="14px" marginBottom="12px">
                      {title}
                    </Ptag>
                    {(deliveryCoverage?.normal_limit ||
                      deliveryCoverage?.caeserian_limit) && (
                        <>
                          <GradeTable
                            style={{
                              marginBottom: "12px",
                            }}
                            title="Delivery Coverage"
                            headers={["Type of Delivery", "Limit"]}
                            body={[
                              [
                                "Normal Room",
                                (deliveryCoverage?.normal_limit &&
                                  formatToRs(deliveryCoverage.normal_limit)) ||
                                "-",
                              ],
                              [
                                "Cesarean",
                                (deliveryCoverage?.caeserian_limit &&
                                  formatToRs(deliveryCoverage.caeserian_limit)) ||
                                "-",
                              ],
                            ]}
                          />
                          {deliveryCoverage.remarks && (
                            <>
                              <Ptag
                                fontWeight="400"
                                fontSize="12px"
                                color="#4a4a4a"
                                marginBottom="36px"
                              >
                                Remarks: {deliveryCoverage.remarks}
                              </Ptag>
                            </>
                          )}
                        </>
                      )}
                    <>
                      {newBornCover.attribute_default && (
                        <GradeTable
                          title="New Born Baby Cover"
                          style={{
                            marginBottom: "12px",
                          }}
                        >
                          <Ptag fontSize="14px" color="#4a4a4a">
                            Limit:{" "}
                            <b>
                              {newBornCover.attribute_default &&
                                formatToRs(newBornCover.attribute_default)}
                            </b>
                          </Ptag>
                        </GradeTable>
                      )}
                      {newBornCover.attribute_remarks && (
                        <>
                          {!newBornCover.attribute_default && (
                            <div
                              style={{
                                backgroundColor: "#440e69",
                                color: "white",
                                fontSize: "12px",
                                fontWeight: "600",
                                padding: "8px 24px",
                                overflow: "hidden",
                                borderRadius: "4px",
                                marginBottom: "12px",
                              }}
                            >
                              New Born Baby Cover
                            </div>
                          )}
                          <Ptag
                            fontWeight="400"
                            fontSize="12px"
                            color="#4a4a4a"
                            marginBottom="36px"
                          >
                            Remarks: {newBornCover.attribute_remarks}
                          </Ptag>
                        </>
                      )}
                    </>
                    <>
                      {prePostNatal.attribute_default && (
                        <GradeTable
                          title="Pre/Post Natal Cover"
                          style={{
                            marginBottom: "12px",
                          }}
                        >
                          <Ptag fontSize="14px" color="#4a4a4a">
                            Limit:{" "}
                            <b>
                              {prePostNatal.attribute_default &&
                                formatToRs(prePostNatal.attribute_default)}
                            </b>
                          </Ptag>
                        </GradeTable>
                      )}
                      {prePostNatal.attribute_remarks && (
                        <>
                          {!prePostNatal.attribute_default && (
                            <div
                              style={{
                                backgroundColor: "#440e69",
                                color: "white",
                                fontSize: "12px",
                                fontWeight: "600",
                                padding: "8px 24px",
                                overflow: "hidden",
                                borderRadius: "4px",
                                marginBottom: "12px",
                              }}
                            >
                              Pre/Post Natal Cover
                            </div>
                          )}
                          <Ptag
                            fontWeight="400"
                            fontSize="12px"
                            color="#4a4a4a"
                            marginBottom="36px"
                          >
                            Remarks: {prePostNatal.attribute_remarks}
                          </Ptag>
                        </>
                      )}
                    </>
                  </section>

                </>
              );
            })}
          </section>
        </GradeSimpleDetail>
      );
    } else if (
      Object.keys(attributeData?.attribute_additional_data["Delivery Coverage"])
        .length === 0
    ) {
      return null;
    } else if (
      attributeData?.attribute_additional_data["Delivery Coverage"][
      "Max Per Day Limit for Normal Room (optional)"
      ]
    ) {
      return (
        <GradeSimpleDetail title="Maternity Coverage">
          <section
            className="grade-summary-inner"
            style={{
              marginBottom: "30px",
            }}
          >
            {attributes &&
              attributes
                .sort((a, b) => maternityOrder[a] - maternityOrder[b])
                .map((value, index) => {
                  const limit =
                    attributeData?.attribute_additional_data[value]
                      .attribute_default;
                  var normal_max =
                    attributeData?.attribute_additional_data[value][
                    "Max Per Day Limit for Normal Room (optional)"
                    ];
                  var icu_max =
                    attributeData?.attribute_additional_data[value][
                    "Max per day limit for ICU (optional)"
                    ];
                  const remark =
                    attributeData?.attribute_additional_data[value]
                      .attribute_remarks;
                  normal_max = normal_max && normal_max.toString();
                  icu_max = icu_max && icu_max.toString();
                  return (
                    <section>
                      {value == "Delivery Coverage" && (
                        <>
                          <GradeTable
                            style={{
                              marginBottom: "12px",
                            }}
                            title="Delivery Coverage"
                            headers={["Type of Delivery", "Limit"]}
                            body={[
                              [
                                "Normal Room",
                                (normal_max && formatToRs(normal_max)) || "-",
                              ],
                              [
                                "Cesarean",
                                (icu_max && formatToRs(icu_max)) || "-",
                              ],
                            ]}
                          />
                          {remark && (
                            <Ptag
                              fontWeight="400"
                              fontSize="12px"
                              color="#4a4a4a"
                              marginBottom="36px"
                            >
                              Remarks: {remark}
                            </Ptag>
                          )}
                        </>
                      )}
                      {value == "New Born Cover" && (
                        <>
                          {limit && (
                            <GradeTable
                              title="New Born Baby Cover"
                              style={{
                                marginBottom: "12px",
                              }}
                            >
                              <Ptag fontSize="14px" color="#4a4a4a">
                                Limit: <b>{limit && formatToRs(limit)}</b>
                              </Ptag>
                            </GradeTable>
                          )}
                          {remark && (
                            <>
                              {!limit && (
                                <div
                                  style={{
                                    backgroundColor: "#440e69",
                                    color: "white",
                                    fontSize: "12px",
                                    fontWeight: "600",
                                    padding: "8px 24px",
                                    overflow: "hidden",
                                    borderRadius: "4px",
                                    marginBottom: "12px",
                                  }}
                                >
                                  New Born Baby Cover
                                </div>
                              )}
                              <Ptag
                                fontWeight="400"
                                fontSize="12px"
                                color="#4a4a4a"
                                marginBottom="36px"
                              >
                                Remarks: {remark}
                              </Ptag>
                            </>
                          )}
                        </>
                      )}
                      {value == "Pre/Post Natal Cover" && (
                        <>
                          {limit && (
                            <GradeTable
                              title="Pre/Post Natal Cover"
                              style={{
                                marginBottom: "12px",
                              }}
                            >
                              <Ptag fontSize="14px" color="#4a4a4a">
                                Limit: <b>{limit && formatToRs(limit)}</b>
                              </Ptag>
                            </GradeTable>
                          )}
                          {remark && (
                            <>
                              {!limit && (
                                <div
                                  style={{
                                    backgroundColor: "#440e69",
                                    color: "white",
                                    fontSize: "12px",
                                    fontWeight: "600",
                                    padding: "8px 24px",
                                    overflow: "hidden",
                                    borderRadius: "4px",
                                    marginBottom: "12px",
                                  }}
                                >
                                  Pre/Post Natal Cover
                                </div>
                              )}
                              <Ptag
                                fontWeight="400"
                                fontSize="12px"
                                color="#4a4a4a"
                                marginBottom="36px"
                              >
                                Remarks: {remark}
                              </Ptag>
                            </>
                          )}
                        </>
                      )}
                    </section>
                  );
                })}
          </section>
        </GradeSimpleDetail>
      );
    }
    return (
      <GradeSimpleDetail title="Maternity Coverage">
        <section className="grade-summary-inner">
          {attributes &&
            attributes
              .sort((a, b) => maternityOrder[a] - maternityOrder[b])
              .map((value, index) => {
                const limit =
                  attributeData?.attribute_additional_data[value]
                    .attribute_default;
                const max =
                  attributeData?.attribute_additional_data[value].attribute_max;
                const min =
                  attributeData?.attribute_additional_data[value].attribute_min;
                const remark =
                  attributeData?.attribute_additional_data[value]
                    .attribute_remarks;
                console.log('non default', attributeData?.attribute_additional_data)
                return (
                  limit && (
                    <div key={index}>
                      <Ptag
                        fontSize="14px"
                        fontWeight="bold"
                        color={colors.primaryColor}
                        marginTop={
                          value === "Delivery Coverage" ? "10px" : "24px"
                        }
                      >
                        {value}
                      </Ptag>
                      {limit && (
                        <Ptag fontSize="14px" marginTop="08px">
                          {" "}
                          <b>{formatToRs(String(limit), false)}</b>
                        </Ptag>
                      )}
                      {min && (
                        <Ptag fontSize="14px" marginTop="08px">
                          Min Value: <b>{formatToRs(min, false)}</b>
                        </Ptag>
                      )}
                      {max && (
                        <Ptag fontSize="14px" marginTop="08px">
                          Max Value: <b>{formatToRs(max, false)}</b>
                        </Ptag>
                      )}
                      {remark && (
                        <Ptag fontSize="12px" marginTop="08px" color="#4a4a4a" fontWeight="400">
                          Remarks: {remark}
                        </Ptag>
                      )}
                    </div>
                  )
                );
              })}
        </section>
      </GradeSimpleDetail>
    );
  };

  const renderRoomRent = () => {
    const attributes =
      attributeData?.attribute_additional_data &&
      Object.keys(attributeData?.attribute_additional_data);
    if (!attributes) return null;
    if (attributes.includes("metro") || attributes.includes("default_metro")) {
      return (
        <GradeSimpleDetail title="Room Rent Per Day Limit">
          <section
            className="grade-summary-inner"
            style={{
              marginBottom: "30px",
            }}
          >
            {attributes.map((attr) => {
              const title =
                attr === "default_metro"
                  ? ""
                  : attr === "metro"
                    ? "Metro Cities"
                    : "Non-Metro Cities";

              const roomRent = attributeData?.attribute_additional_data[attr];
              return (
                <>
                  <section>
                    <Ptag fontSize="14px" marginBottom="12px">
                      {title}
                    </Ptag>
                    <GradeTable
                      headers={[
                        "Type of Room ",
                        "% of Sum Insured",
                        "Max Limit",
                      ]}
                      body={[
                        [
                          "Normal Room",
                          (roomRent.normal.limit &&
                            roomRent.normal.limit + "%") ||
                          "-",
                          (roomRent?.normal?.max &&
                            formatToRs(roomRent.normal.max)) ||
                          "-",
                        ],
                        [
                          "ICU",
                          (roomRent.icu.limit && roomRent.icu.limit + "%") ||
                          "-",
                          (roomRent?.icu?.max &&
                            formatToRs(roomRent.icu.max)) ||
                          "-",
                        ],
                      ]}
                      style={{
                        marginBottom: "24px",
                      }}
                    />
                    {roomRent.remarks && (
                      <Ptag
                        fontWeight="400"
                        fontSize="12px"
                        color="#4a4a4a"
                        marginBottom="36px"
                      >
                        Remarks: {roomRent.remarks}
                      </Ptag>
                    )}
                  </section>
                </>
              );
            })}
          </section>
        </GradeSimpleDetail>
      );
    }

    const returnValue = attributeData?.attribute_default;
    return (
      returnValue && (
        <GradeSimpleDetail title={name}>
          <section>
            {attributeData?.attribute_default && (
              <Ptag fontSize="14px" marginTop="08px">
                {" "}
                <b>{formatToRs(attributeData?.attribute_default, false)}</b>
              </Ptag>
            )}
            {attributeData?.attribute_min && (
              <Ptag fontSize="14px" marginTop="08px">
                Min Value:{" "}
                <b>{formatToRs(attributeData?.attribute_min, false)}</b>
              </Ptag>
            )}
            {attributeData?.attribute_max && (
              <Ptag fontSize="14px" marginTop="08px">
                Max Value:{" "}
                <b>{formatToRs(attributeData?.attribute_max, false)}</b>
              </Ptag>
            )}
            {attributeData?.attribute_remarks && (
              <Ptag fontSize="12px" marginTop="08px" fontWeight="400" color="#4a4a4a">
                Remarks: {attributeData?.attribute_remarks}
              </Ptag>
            )}
          </section>
        </GradeSimpleDetail>
      )
    );
  };

  const renderSelectables = () => {
    let sumInsuredArray = reusables.find(({ attribute_product_mapping_id }) => attribute_product_mapping_id === id) && 
    reusables.find(({ attribute_product_mapping_id }) => attribute_product_mapping_id === id).selectable_values || [];
    sumInsuredArray = sumInsuredArray.map((val)=>formatToRs(val))
    if (sumInsuredArray.length > 1) {
      const allButLast = sumInsuredArray.slice(0, -1).join(',  ');
      const last = sumInsuredArray.slice(-1);
      const result = `${allButLast}  &  ${last}`;
      return result;
    } else if(sumInsuredArray.length == 0){
      const result = sumInsuredArray[0] || '';
      return result;
    } else {
      return ''
    }
  };

  const optionalRenderer = (localName) => {
    switch (localName) {
      case "Sum Insured":
        return (
          <>
            <GradeSimpleDetail title="Sum Insuredddd">
              <Ptag fontSize="14px" marginTop="8px">
                {" "}
                <b>
                  {attributeData.attribute_default ?
                    formatToRs(attributeData.attribute_default): renderSelectables()}
                </b>
              </Ptag>
            </GradeSimpleDetail>
            {grade?.dependents_covered && (
              <>
                {grade?.dependents_covered?.dependents_allowed.length > 0 && (
                  <GradeSimpleDetail
                    title="Dependents Covered"
                    text={grade?.dependents_covered?.dependents_allowed.join(
                      ", "
                    )}
                  />
                )}
                <section className="summary-horizontal-wrapper">
                  {grade?.dependents_covered?.max_number_children && (
                    <GradeSimpleDetail
                      title="Max No. of Children"
                      text={`${grade?.dependents_covered?.max_number_children}`}
                    />
                  )}
                  {!!childrenAgeLimitExist && (
                    <GradeSimpleDetail title="Children Age Limit">
                      {(grade?.dependents_covered?.children_age_limit?.min ||
                        grade?.dependents_covered?.children_age_limit?.min ===
                        0) && (
                          <Ptag fontSize="14px" marginTop="08px">
                            Min Years:{" "}
                            <b>
                              {grade?.dependents_covered?.children_age_limit?.min}{" "}
                              years
                            </b>
                          </Ptag>
                        )}
                      {grade?.dependents_covered?.children_age_limit?.max && (
                        <Ptag fontSize="14px" marginTop="08px">
                          Max Years:{" "}
                          <b>
                            {grade?.dependents_covered?.children_age_limit?.max}{" "}
                            years
                          </b>
                        </Ptag>
                      )}
                    </GradeSimpleDetail>
                  )}
                  {!!parentAgeLimitExist && (
                    <GradeSimpleDetail title="Parent Age Limit">
                      {!!grade?.dependents_covered?.parental_age_limit?.min ||
                        (grade?.dependents_covered?.parental_age_limit?.min ==
                          0 && (
                            <Ptag fontSize="14px" marginTop="08px">
                              Min Years:{" "}
                              <b>
                                {
                                  grade?.dependents_covered?.parental_age_limit
                                    ?.min
                                }{" "}
                                years
                              </b>
                            </Ptag>
                          ))}
                      {!!grade?.dependents_covered?.parental_age_limit?.max && (
                        <Ptag fontSize="14px" marginTop="08px">
                          Max Years:{" "}
                          <b>
                            {grade?.dependents_covered?.parental_age_limit?.max}{" "}
                            years
                          </b>
                        </Ptag>
                      )}
                    </GradeSimpleDetail>
                  )}
                </section>
              </>
            )}
          </>
        );
      case "Co Payment":
        const escp =
          attributeData?.attribute_additional_data[
            "For Employee, Spouse and Children"
          ]?.attribute_default;
        const parent =
          attributeData?.attribute_additional_data["For Parents/In-laws"]
            ?.attribute_default;
        const escp_max =
          attributeData?.attribute_additional_data[
            "For Employee, Spouse and Children"
          ]?.attribute_max;
        const parent_max =
          attributeData?.attribute_additional_data["For Parents/In-laws"]
            ?.attribute_max;
        const escp_min =
          attributeData?.attribute_additional_data[
            "For Employee, Spouse and Children"
          ]?.attribute_min;
        const parent_min =
          attributeData?.attribute_additional_data["For Parents/In-laws"]
            ?.attribute_min;
        // const return
        return (
          attributeData?.attribute_additional_data &&
          attributeData?.attribute_additional_data?.[
          "For Employee, Spouse and Children"
          ] &&
          Object.keys(
            attributeData?.attribute_additional_data?.[
            "For Employee, Spouse and Children"
            ]
          ).length > 0 &&
          escp && (
            <>
              <GradeSimpleDetail title="Co Payment">
                <section style={{ display: "flex", gap: "8rem" }}>
                  {escp && (
                    <div>
                      <Ptag fontSize="14px" marginTop="08px">
                        Self, Spouse and Children:{" "}
                        <b>{escp}</b>
                      </Ptag>
                      {escp_min && (
                        <Ptag fontSize="14px" marginTop="08px">
                          Min Value: <b>{escp_min}</b>
                        </Ptag>
                      )}
                      {escp_max && (
                        <Ptag fontSize="14px" marginTop="08px">
                          Max Value: <b>{escp_max}</b>
                        </Ptag>
                      )}
                    </div>
                  )}
                  {parent && (
                    <div>
                      <Ptag fontSize="14px" marginTop="08px">
                        Parents/In-Laws: <b>{parent}</b>
                      </Ptag>
                      {parent_min && (
                        <Ptag fontSize="14px" marginTop="08px">
                          Min Value: <b>{parent_min}</b>
                        </Ptag>
                      )}
                      {parent_max && (
                        <Ptag fontSize="14px" marginTop="08px">
                          Max Value: <b>{parent_max}</b>
                        </Ptag>
                      )}
                    </div>
                  )}
                </section>
              </GradeSimpleDetail>
            </>
          )
        );
      case "Disease Wise Sub-limit":
        const data = attributeData?.attribute_additional_data;
        return (
          data?.length > 0 &&
          Object.keys(data[0]).length > 0 && (
            <GradeSimpleDetail title="Disease Wise Sub-limit">
              <section
                className="grade-summary-inner"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "2rem",
                }}
              >
                {data.map((disease, index) => (
                  <section>
                    {disease?.["Disease Name"] && (
                      <Ptag fontSize="14px" marginBottom="08px">
                        {data.length > 1 ? `${index + 1}.` : ""} {disease?.["Disease Name"]}
                      </Ptag>
                    )}
                    {disease?.attribute_default && (
                      <Ptag fontSize="14px" marginBottom="08px">
                        {" "}
                        <b>{formatToRs(disease?.attribute_default, false)}</b>
                      </Ptag>
                    )}
                    {disease?.attribute_remarks && (
                      <Ptag fontSize="12px" color="#4a4a4a" fontWeight="400">
                        Remarks: {disease?.attribute_remarks}
                      </Ptag>
                    )}
                  </section>
                ))}
              </section>
            </GradeSimpleDetail>
          )
        );
      case "Maternity Coverage":
        return renderMaternity();
      case "Room Rent Limit":
        return renderRoomRent();
      default:
        const returnValue = attributeData?.attribute_default;
        return (
          returnValue && (
            <GradeSimpleDetail title={name}>
              <section>
                {attributeData?.attribute_default && (
                  <Ptag fontSize="14px" marginTop="08px">
                    {" "}
                    <b>{formatToRs(attributeData?.attribute_default, false)}</b>
                  </Ptag>
                )}
                {attributeData?.attribute_min && (
                  <Ptag fontSize="14px" marginTop="08px">
                    Min Value:{" "}
                    <b>{formatToRs(attributeData?.attribute_min, false)}</b>
                  </Ptag>
                )}
                {attributeData?.attribute_max && (
                  <Ptag fontSize="14px" marginTop="08px">
                    Max Value:{" "}
                    <b>{formatToRs(attributeData?.attribute_max, false)}</b>
                  </Ptag>
                )}
                {attributeData?.attribute_remarks && (
                  <Ptag fontSize="12px" marginTop="08px" fontWeight="400" color="#4a4a4a">
                    Remarks: {attributeData?.attribute_remarks}
                  </Ptag>
                )}
              </section>
            </GradeSimpleDetail>
          )
        );
    }
  };
  return <>{optionalRenderer(name)}</>;
}

export default RenderGradeSummarySwitch;
